import React, { Component } from 'react';

class ChangePasswordModal extends Component {

    render() {
        const { 
            action, 
            adminUsersModel, 
            editMode, 
            SaveChangePassword, 
            CloseChangePasswordModal,
            ChangeOldPassword,
            ChangeU_FMB_PasswdNew,
            ChangeU_FMB_Passwdconfirm,
            EyeVisibilityOld,
            EyeVisibilityNew,
            EyeVisibilityConfirm,
            typeVisibilityOld,
            typeVisibilitynew,
            typeVisibilityconfirm
        } = this.props;

        return (
            <div className="modal fade bd-example-modal-lg modal-open scroll" id="changePasswordModal" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="changePasswordModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-open" role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">Cambiar contraseña</h4>
                            &nbsp;
                            <button type="button" className="close" onClick={CloseChangePasswordModal} aria-label="Close">
                                <span className="text-white" aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body" >
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-1">
                                    </div>
                                    <div className="col-10">
                                        <div className="w-100 tab-pane fade show active " aria-labelledby="nav-home-tab-Contenido" style={{ marginBottom: 0, minheight: 400, maxHeight: 500 }}>
                                            {/*CONTRASEÑA DE USUARIO*/}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Contraseña actual</span>
                                                </div>
                                                    <input className="form-control"
                                                            style={{backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000'}}
                                                            type={ typeVisibilityOld === false ? 'text' : 'password' }
                                                            disabled={(action === 2 && !editMode) ? true : false}
                                                            onChange={ChangeOldPassword}
                                                            value={adminUsersModel.OldPassword ? adminUsersModel.OldPassword : ""}
                                                    />
                                                    <div className="input-group-prepend" style={{width: 40}}>
                                                        <span className="input-group-text"  style={{background: ''}}
                                                        onClick = {() => EyeVisibilityOld()}><i className={typeVisibilityOld === false ? 'fa fa-eye' : 'fa fa-eye-slash'}/></span>
                                                    </div>
                                            </div>
                                            {/*NUEVA CONTRASEÑA DE USUARIO*/}
                                            {(action === 2 && editMode) &&
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Contraseña nueva</span>
                                                    </div>
                                                        <input className="form-control"
                                                                style={{
                                                                    backgroundColor: 'transparent',
                                                                    borderColor: '#ced4da',
                                                                    color: '#000'
                                                                }}
                                                                type={ typeVisibilitynew === false ? 'text' : 'password' }
                                                                disabled={(action === 2 && !editMode) ? true : false}
                                                                onChange={ChangeU_FMB_PasswdNew}
                                                                value={adminUsersModel.U_FMB_passwdNew ? adminUsersModel.U_FMB_passwdNew : ""}
                                                        />
                                                        <div className="input-group-prepend" style={{width: 40}}>
                                                            <span className="input-group-text"  style={{background: ''}}
                                                            onClick = {() => EyeVisibilityNew()}><i className={typeVisibilitynew === false ? 'fa fa-eye' : 'fa fa-eye-slash'}/></span>
                                                        </div>
                                                </div>
                                            }
                                                
                                            {/*CONFIRMAR CONTRASEÑA DE USUARIO*/}
                                            {(action === 2 && editMode) &&
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Confirmar contraseña</span>
                                                    </div>
                                                        <input className="form-control"
                                                                style={{
                                                                    backgroundColor: 'transparent',
                                                                    borderColor: '#ced4da',
                                                                    color: '#000'
                                                                }}
                                                                type={ typeVisibilityconfirm === false ? 'text' : 'password' }
                                                                disabled={(action === 2 && !editMode) ? true : false}
                                                                onChange={ChangeU_FMB_Passwdconfirm}
                                                                value={adminUsersModel.U_FMB_passwdConfirm ? adminUsersModel.U_FMB_passwdConfirm : ""}
                                                        />
                                                        <div className="input-group-prepend" style={{width: 40}}>
                                                            <span className="input-group-text"  style={{background: ''}}
                                                            onClick = {() => EyeVisibilityConfirm()}><i className={typeVisibilityconfirm === false ? 'fa fa-eye' : 'fa fa-eye-slash'}/></span>
                                                        </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className="col-1">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white"
                                onClick={CloseChangePasswordModal}>
                                    Cerrar
                            </button>
                            {action === 2 && editMode && (
                                <button type="button" className="btn botonCorrect" 
                                    onClick={SaveChangePassword}>
                                        Cambiar contraseña
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ChangePasswordModal;